var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperiencesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 65,
    height: 64,
    rx: 11,
    fill: "#DAA28F",
    stroke: "#434343",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 29.9368L54.4668 41.2532V50.1211C54.4668 50.8361 53.9122 51.3636 53.2915 51.3636H14.7087C14.0879 51.3636 13.5334 50.8365 13.5334 50.1211V41.2532L34.0001 29.9368Z",
    fill: "white",
    stroke: "#434343",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.289 17.3316V17.3322C38.2895 18.2104 38.9989 18.6233 39.3946 18.7737C39.8356 18.9415 40.3466 18.9896 40.7913 18.9774C41.2402 18.965 41.7322 18.888 42.1479 18.7223C42.3536 18.6403 42.5967 18.5146 42.8035 18.3165C43.0201 18.109 43.2383 17.7763 43.2386 17.3323V17.3316V12.2474C43.2386 10.8509 42.133 9.66666 40.7053 9.66666H27.2958C25.8681 9.66666 24.7625 10.8509 24.7625 12.2474V17.3316C24.7625 17.9774 25.264 18.2846 25.4187 18.3671C25.6267 18.478 25.8534 18.5362 26.0284 18.571C26.3966 18.6441 26.8397 18.6698 27.246 18.6661C27.6538 18.6623 28.091 18.6283 28.4509 18.5546C28.622 18.5195 28.8376 18.4635 29.0345 18.3642C29.1325 18.3148 29.2785 18.2289 29.4112 18.0857C29.5527 17.9331 29.7111 17.6767 29.7111 17.3316V14.7317H38.289V17.3316Z",
    fill: "white",
    stroke: "#434343",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.294 40.0057L54.2939 40.0057L36.2677 41.9097L31.7322 41.9102L13.7064 40.0063C12.7611 39.9061 12 39.0743 12 38.0305V20.3171C12 19.1918 12.8775 18.3316 13.896 18.3316H54.104C55.1225 18.3316 56 19.1918 56 20.3171V38.0305C56 39.074 55.2388 39.906 54.294 40.0057Z",
    fill: "#F2E9D8",
    stroke: "#434343",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6794 43.825C30.6794 45.6692 32.1371 47.2172 33.9999 47.2172C35.8625 47.2172 37.3203 45.6698 37.3203 43.825V42.7954V40.2119C37.3203 38.3677 35.8627 36.8197 33.9999 36.8197C32.1379 36.8197 30.6794 38.3669 30.6794 40.2119V43.825Z",
    fill: "white",
    stroke: "#434343",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencesIcon);
export default __webpack_public_path__ + "static/media/experiences-icon.978d49fde8cd59f72f6b9f77ba924e76.svg";
export { ForwardRef as ReactComponent };